export enum InsuranceCostAbsorptionLevel {
  FULL = 'FULL',
  SEVENTY = 'SEVENTY',
  FIFTY = 'FIFTY',
  THIRTY = 'THIRTY',
  NULL_WITH_SURCHARGE_43B = 'NULL_WITH_SURCHARGE_43B',
  NULL = 'NULL',
}

export function insuranceCostAbsorptionLevelToPercentage(
  level: InsuranceCostAbsorptionLevel,
): number {
  switch (level) {
    case InsuranceCostAbsorptionLevel.FULL:
      return 100;
    case InsuranceCostAbsorptionLevel.SEVENTY:
      return 70;
    case InsuranceCostAbsorptionLevel.FIFTY:
      return 50;
    case InsuranceCostAbsorptionLevel.THIRTY:
      return 30;
    case InsuranceCostAbsorptionLevel.NULL_WITH_SURCHARGE_43B:
      return 0;
    default:
      return 0;
  }
}
